import { render, staticRenderFns } from "./ThemaOverview.vue?vue&type=template&id=fe1c7aa2&"
import script from "./ThemaOverview.vue?vue&type=script&lang=js&"
export * from "./ThemaOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports